import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { StpServicesModule } from '@app/stp/services/stp-services.module';

import { FeatureState } from '@global/infrastructure/interfaces/feature-state';
import { JourneyConfig } from '@app/stp/services/journey-config/journey.config';
import { JourneyFeatures } from '@app/infrastructure/data/journey-features';

@Injectable({
  providedIn: StpServicesModule,
})
export class JourneyConfigService {
  getJourneyDetails(url: string): Observable<FeatureState> {
    const urlParts = url.split('/').filter((u) => u);
    let key = urlParts.length > 0 ? urlParts[0] : 'load';
    if (
      urlParts.find(
        (u) =>
          u === JourneyFeatures.loadPolicy.path || u === 'load?enableMocks=true'
      )
    ) {
      key = JourneyFeatures.loadPolicy.path;
    } else if (
      urlParts.find((u) => u === JourneyFeatures.personalDetails.path)
    ) {
      key = JourneyFeatures.personalDetails.path;
    } else if (
      urlParts.find((u) => u === JourneyFeatures.drivingLicenseNumber.path)
    ) {
      key = JourneyFeatures.drivingLicenseNumber.path;
    } else if (
      urlParts.find((u) => u === JourneyFeatures.drivingHistory.path)
    ) {
      key = JourneyFeatures.drivingHistory.path;
    } else if (
      urlParts.find(
        (u) =>
          u === JourneyFeatures.addDriver.path ||
          u === JourneyFeatures.editDriver.path
      )
    ) {
      key = JourneyFeatures.addDriver.path;
    } else if (
      url === JourneyFeatures.reviewFull.path ||
      url === `/${JourneyFeatures.reviewFull.path}`
    ) {
      key = JourneyFeatures.reviewFull.path;
    } else if (
      url === JourneyFeatures.reviewDirectDebit.path ||
      url === `/${JourneyFeatures.reviewDirectDebit.path}`
    ) {
      key = JourneyFeatures.reviewDirectDebit.path;
    } else if (url.indexOf(JourneyFeatures.directDebitReview.path) >= 0) {
      key = JourneyFeatures.directDebitReview.path;
    } else if (
      url === JourneyFeatures.confirmFull.path ||
      url === `/${JourneyFeatures.confirmFull.path}`
    ) {
      key = JourneyFeatures.confirmFull.path;
    } else if (
      url === JourneyFeatures.confirmAutoRenewal.path ||
      url === `/${JourneyFeatures.confirmAutoRenewal.path}`
    ) {
      key = JourneyFeatures.confirmAutoRenewal.path;
    } else if (
      url === JourneyFeatures.confirmDirectDebit.path ||
      url === `/${JourneyFeatures.confirmDirectDebit.path}`
    ) {
      key = JourneyFeatures.confirmDirectDebit.path;
    } else if (
      urlParts.find((u) => u === JourneyFeatures.directDebitDisplay.path)
    ) {
      key = JourneyFeatures.directDebitDisplay.path;
    } else if (
      urlParts.find((u) => u === JourneyFeatures.directDebitEdit.path)
    ) {
      key = JourneyFeatures.directDebitEdit.path;
    } else if (
      urlParts.find((u) => u === JourneyFeatures.prefferedPaymentDate.path)
    ) {
      key = JourneyFeatures.prefferedPaymentDate.path;
    } else if (urlParts.find((u) => u === JourneyFeatures.creditCard.path)) {
      key = JourneyFeatures.creditCard.path;
    } else if (url.indexOf(JourneyFeatures.directDebitNew.path) >= 0) {
      key = JourneyFeatures.directDebitNew.path;
    } else if (
      url === JourneyFeatures.yourCarPerm.path ||
      url === `/${JourneyFeatures.yourCarPerm.path}`
    ) {
      key = JourneyFeatures.yourCarPerm.path;
    } else if (
      url === JourneyFeatures.yourCarTemp.path ||
      url === `/${JourneyFeatures.yourCarTemp.path}`
    ) {
      key = JourneyFeatures.yourCarTemp.path;
    } else if (
      url === JourneyFeatures.yourDriversPerm.path ||
      url === `/${JourneyFeatures.yourDriversPerm.path}`
    ) {
      key = JourneyFeatures.yourDriversPerm.path;
    } else if (
      url === JourneyFeatures.yourDriversMoreInfo.path ||
      url === `/${JourneyFeatures.yourDriversMoreInfo.path}`
    ) {
      key = JourneyFeatures.yourDriversMoreInfo.path;
    } else if (
      url === JourneyFeatures.yourDriversTemp.path ||
      url === `/${JourneyFeatures.yourDriversTemp.path}`
    ) {
      key = JourneyFeatures.yourDriversTemp.path;
    } else if (
      url === JourneyFeatures.yourTemporaryEuropeanCover.path ||
      url === `/${JourneyFeatures.yourTemporaryEuropeanCover.path}`
    ) {
      key = JourneyFeatures.yourTemporaryEuropeanCover.path;
    } else if (
      url === JourneyFeatures.dashboardSelect.path ||
      url === `/${JourneyFeatures.dashboardSelect.path}`
    ) {
      key = JourneyFeatures.dashboardSelect.path;
    } else if (
      url === JourneyFeatures.changeType.path ||
      url === `/${JourneyFeatures.changeType.path}`
    ) {
      key = JourneyFeatures.changeType.path;
    } else if (
      url === JourneyFeatures.changeDate.path ||
      url === `/${JourneyFeatures.changeDate.path}`
    ) {
      key = JourneyFeatures.changeDate.path;
    } else if (
      url === JourneyFeatures.dashboardUpdate.path ||
      url === `/${JourneyFeatures.dashboardUpdate.path}`
    ) {
      key = JourneyFeatures.dashboardUpdate.path;
    } else if (
      url === JourneyFeatures.renewalPreference.path ||
      url === `/${JourneyFeatures.renewalPreference.path}`
    ) {
      key = JourneyFeatures.renewalPreference.path;
    } else if (url.indexOf(JourneyFeatures.yourDrivingHistory.path) >= 0) {
      key = JourneyFeatures.yourDrivingHistory.path;
    } else if (url.indexOf(JourneyFeatures.yourLicenceNumber.path) >= 0) {
      key = JourneyFeatures.yourLicenceNumber.path;
    } else if (url.indexOf(JourneyFeatures.personalDetails.path) >= 0) {
      key = JourneyFeatures.personalDetails.path;
    } else if (url.indexOf(JourneyFeatures.drivingLicenseNumber.path) >= 0) {
      key = JourneyFeatures.drivingLicenseNumber.path;
    } else if (url.indexOf(JourneyFeatures.drivingHistory.path) >= 0) {
      key = JourneyFeatures.drivingHistory.path;
    } else if (url.indexOf(JourneyFeatures.yourDriversDetails.path) >= 0) {
      key = JourneyFeatures.yourDriversDetails.path;
    } else if (url.indexOf(JourneyFeatures.chooseMainDriver.path) >= 0) {
      key = JourneyFeatures.chooseMainDriver.path;
    } else if (url.indexOf(JourneyFeatures.yourAddress.path) >= 0) {
      key = JourneyFeatures.yourAddress.path;
    } else if (url.indexOf(JourneyFeatures.yourPostalAddress.path) >= 0) {
      key = JourneyFeatures.yourPostalAddress.path;
    } else if (url.indexOf(JourneyFeatures.parkingDetails.path) >= 0) {
      key = JourneyFeatures.parkingDetails.path;
    } else if (url.indexOf(JourneyFeatures.premium.path + '?') >= 0) {
      key = JourneyFeatures.premium.path;
    } else if (
      url === JourneyFeatures.cancelPolicy.path ||
      url === `/${JourneyFeatures.cancelPolicy.path}`
    ) {
      key = JourneyFeatures.cancelPolicy.path;
    } else if (
      url === JourneyFeatures.anotherReason.path ||
      url === `/${JourneyFeatures.anotherReason.path}`
    ) {
      key = JourneyFeatures.anotherReason.path;
    }

    const selectedDetails = JourneyConfig[key] || {};
    return of(selectedDetails);
  }
}
